import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header>
      <div className="container header-container">
        <Link to="/" className="logo-container" >
          <img
            src="/logo.png"
            alt="DK RO Sales & Service"
            className="logo-img"
          />
        </Link>

        <nav>
          <ul className="nav-menu">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/privacy-policy">Privacy</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}